import { global } from '../constants';

export const data = {
  banner: {
    background: global.banner + 'diamond-banner.webp',
    title: 'Diamonds and Jewelry',
    crumb: 'Diamonds and Jewelry',
  },
  intro: {
    img: global.banner + 'diamond-2.webp',
    tagline: "TRUSTED BY THE WORLD'S FINEST",
    heading: 'Secure, Specialized Logistics for High-Value Goods',
    description:
      'With years of experience handling high-value goods, we offer trusted logistics solutions designed for the diamond and jewelry sector. From origin to destination, our secure chain of custody ensures your assets are protected every step of the way.',
  },

  services: {
    title: 'All services',
    subtitle: 'Trusted For Our Services',
    description:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.',
    services: [
      {
        icon: global.icons + 'pic1.png',
        serial: '01',
        title: 'Air Freight',
        description:
          'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
      },
      {
        icon: global.icons + 'pic2.png',
        serial: '02',
        title: 'Road Freight',
        description:
          'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
      },
      {
        icon: global.icons + 'pic3.png',
        serial: '03',
        title: 'Ocean Freight',
        description:
          'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
      },
      {
        icon: global.icons + 'pic4.png',
        serial: '04',
        title: 'Rail Freight',
        description:
          'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
      },
      {
        icon: global.icons + 'pic5.png',
        serial: '05',
        title: 'Warehousing',
        description:
          'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
      },
      {
        icon: global.icons + 'pic6.png',
        serial: '06',
        title: 'Project Cargo',
        description:
          'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
      },
    ],
  },

  estimation: {
    title: 'TAILORED EXECUTION',
    subtitle: 'Built Around Your Business Needs',
    description:
      "Whether you're shipping from a boutique or managing global inventory, our services integrate seamlessly with your supply chain for efficient, secure movement of valuable goods.",
    solutions: [
      {
        serial: '01',
        icon: global.eicons + 'pic1.png',
        title: 'Integrated Workflows',
        description:
          'From shipping documents to customs procedures, our solutions fit smoothly into your existing logistics and supply chain processes.',
      },
      {
        serial: '02',
        icon: global.eicons + 'pic2.png',
        title: 'Global Vault Access',
        description:
          'We provide access to strategically located high-security vaults and bonded warehouses across key diamond and jewelry hubs worldwide.',
      },
      {
        serial: '03',
        icon: global.eicons + 'pic3.png',
        title: ' Discreet Handling',
        description:
          'We operate with utmost confidentiality — packaging, documentation, and delivery all reflect the need for privacy and professionalism.',
      },
    ],
  },

  blogs: {
    title: 'OUR STANDARDS',
    subtitle: 'Ensuring Excellence Through Every Detail',
    description:
      'From security to compliance, our approach is shaped by precision and discipline. We don’t just move valuables — we protect trust, reputation, and legal integrity at every point in the journey.',
    blogs: [
      {
        image: global.blog + 'card-1.png',
        icon: '🛡️',
        title: 'Uncompromising Security Protocols',
        description:
          'Every shipment is guarded by strict security measures — from discreet collection to armed transit and restricted-access vaults. Our clients trust us to protect the irreplaceable.',
      },
      {
        image: global.blog + 'card-2.jpeg',
        icon: '📄',
        title: 'Flawless Compliance Management',
        description:
          'We navigate international regulations with precision — ensuring each shipment meets export controls, valuation requirements, and customs documentation standards.',
      },
    ],
  },
};
